function getTracker() {
    if (!window.kontikiReactTracker) {
        window.kontikiReactTracker = {
            _pending: 0,
            _fired: false,
            register: function() {
                this._pending++;
            },
            complete: function() {
                if (this._pending > 0) {
                    this._pending--;
                }
                if (this._pending === 0 && !this._fired) {
                    this._fired = true;
                    document.dispatchEvent(new CustomEvent('allReactLoaded'));
                }
            }
        };
    }
    return window.kontikiReactTracker;
}

export function registerReactApp() {
    getTracker().register();
}

export function reactAppLoaded() {
    getTracker().complete();
}


// WEBPACK FOOTER //
// ./src/services/reactLoadTracker.js